module.exports = __webpack_public_path__ + "static/media/A4-portrait-v2.233619f9.png";